module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/blog your pathPrefix should be "blog"
  siteTitle: 'Alisha Jeddeloh', // Navigation and Site Title
  siteTitleAlt: 'The website of Alisha Jeddeloh', // Alternative Site title for SEO
  siteTitleShort: 'The website of Alisha Jeddeloh', // short_name for manifest
  siteUrl: 'https://alishajeddeloh.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: 'images/logo.png', // Used for SEO and manifest, path to your image you placed in the 'static' folder
  siteDescription: 'This is where they post things!',
  author: 'Author', // Author for schemaORGJSONLD
  organization: '',

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@amjeddeloh', // Twitter Username
  ogSiteName: 'Alisha Jeddeloh', // Facebook Site Name
  ogLanguage: 'en_US',
  googleAnalyticsID: '',

  // Manifest and Progress color
  themeColor: '#5348FF',
  backgroundColor: '#2b2e3c',

  // Social component
  twitter: 'https://twitter.com/amjeddeloh/',
  twitterHandle: '@amjeddeloh',
  github: '',
  linkedin: '',
};
